import { createLoggingClient, type AuthService } from "@kamstrup/flow-core/http";
import { createLogger, type Logger } from "@kamstrup/flow-core/logging";
import { getAccessTokenAsync, msalInstance } from "@kamstrup/flow-core/security";
import { AxiosInstance } from "axios";
import { getEnv } from "src/config";

const { REACT_APP_BACKEND_URL, REACT_APP_FLOW_ACCESS_TOKEN_SCOPE } = getEnv();

interface IServices {
  loggingClient: AxiosInstance;
  logger: Logger;
  authService: AuthService;
}

let cachedServices: IServices | undefined = undefined;

function buildAuthService(): AuthService {
  return {
    getAccessToken: (scopes) => getAccessTokenAsync(scopes),
    getIdTokenClaims: () => msalInstance.getActiveAccount()?.idTokenClaims,
    logout: async () => {
      await msalInstance
        .logoutRedirect({
          postLogoutRedirectUri: `${getEnv().REACT_APP_LOGOUT_URI}${encodeURI(window.location.href)}`,
        })
        .catch((error) => {
          console.error("Logout failed:", error);
        });
    },
  };
}

function buildServices(): IServices {
  const authScopes = [REACT_APP_FLOW_ACCESS_TOKEN_SCOPE];
  const authService = buildAuthService();

  const loggingClient = createLoggingClient(REACT_APP_BACKEND_URL, authService, authScopes);
  const logger = createLogger(loggingClient, { consoleOutput: false });

  return {
    loggingClient,
    logger,
    authService
  };
}

export function getServices(): IServices {
  if (!cachedServices) {
    cachedServices = buildServices();
  }

  return cachedServices;
}